/* ===== Cenzio — sepet kucuk dokunuslari =====
   1) Tek degerli "Depth" satirini gizler — her urunde ayni, gurultu.
   2) Satir sonundaki bosta kalan virgulleri temizler.
   3) Adet 1 iken tekrar eden birim fiyat satirini gizler.
   4) Odeme butonuna kayan ok + altina guvence satiri ekler.
   Gorsellerin beyaz zeminini eritme isi cz-mount.js'te — orada her
   gorsel tek tek olculuyor, oda fotograflarina dokunulmuyor.
   Tum yazmalar korumali: ayni deger tekrar yazilmaz, boylece
   MutationObserver sonsuz donguye girmez.
   ============================================================ */
(function () {
  'use strict';

  var ARROW = 'M5 12h13 M12.6 6.2 18.4 12l-5.8 5.8';
  var LOCK = 'M7 10V7.5a5 5 0 0 1 10 0V10 M5.4 10h13.2v9.2H5.4z';

  function setDisplay(el, v) {
    if (el && el.style.display !== v) el.style.display = v;
  }

  function hideNoiseOptions(root) {
    (root || document).querySelectorAll('.product-option').forEach(function (el) {
      var t = el.textContent.replace(/\s+/g, ' ').trim();
      if (/^depth\s*:/i.test(t)) setDisplay(el, 'none');
    });
  }

  function tidyItems(root) {
    (root || document).querySelectorAll('.cart-item').forEach(function (row) {
      row.querySelectorAll('dl .product-option dd').forEach(function (dd) {
        var t = dd.textContent.replace(/\s*,\s*$/, '');
        if (t !== dd.textContent) dd.textContent = t;
      });
      var q = row.querySelector('.quantity__input');
      var unit = row.querySelector('.cart-item__details > .product-option');
      if (q && unit) setDisplay(unit, q.value === '1' ? 'none' : '');
    });
  }

  function svgIcon(cls, d) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('class', cls);
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', d);
    svg.appendChild(p);
    return svg;
  }

  function addArrow(root) {
    (root || document).querySelectorAll('.cart__checkout-button').forEach(function (b) {
      if (b.querySelector('.cz-co-arrow')) return;
      b.appendChild(svgIcon('cz-co-arrow', ARROW));
    });
  }

  /* Butonun altinda, gercek politikalarimizdan gelen tek satir. */
  function addAssurance(root) {
    (root || document).querySelectorAll('.cart__ctas').forEach(function (box) {
      if (box.querySelector('.cz-assure')) return;
      if (!box.querySelector('.cart__checkout-button')) return;
      var p = document.createElement('p');
      p.className = 'cz-assure';
      p.appendChild(svgIcon('cz-assure__i', LOCK));
      p.appendChild(document.createTextNode('Secure checkout · Free U.S. shipping · Damage-free guarantee'));
      box.appendChild(p);
    });
  }

  function apply() {
    hideNoiseOptions();
    tidyItems();
    addArrow();
    addAssurance();
  }

  function watch(node) {
    if (!node || !('MutationObserver' in window)) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 60);
    }).observe(node, { childList: true, subtree: true });
  }

  function init() {
    apply();
    watch(document.querySelector('cart-drawer') || document.body);
    var page = document.querySelector('.cart__contents');
    if (page) watch(page.parentNode || page);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('quantity__input')) setTimeout(apply, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
